import { IPayer } from '@alberta/konexi-shared';
import { PayerDB } from 'src/app/common/repository/databases';
import { PrescriptionNodeValue } from 'src/app/shared/models/prescription/prescription-node-value.model';
import { PrescriptionRequestDto } from 'src/app/shared/models/prescription/prescription-request-dto.model';
import { QueryService } from 'src/app/shared/services/query/query.service';

import { PrescriptionChainHandler } from './prescription-chain-handler';

export class PayerHandler extends PrescriptionChainHandler {
  constructor(private _queryService: QueryService) {
    super();
  }
  async handleRequest(prescriptionRequestDto: PrescriptionRequestDto, request: PrescriptionNodeValue) {
    const payer = await this._queryService.get<IPayer>(request.payerId, PayerDB);
    if (payer) {
      prescriptionRequestDto.payer = {
        name: payer.name,
        numberOfInsured: request.numberOfInsured,
      };
    }
    return this.next.handleRequest(prescriptionRequestDto, request);
  }
}
